import { MaterialType } from '@mnd-frontend/graphql-schema';
import IconCalendar from '@mnd-frontend/icons/components/Calendar';
import IconLearningVideo from '@mnd-frontend/icons/components/LearningVideo';
import IconStory from '@mnd-frontend/icons/components/Story';
import IconTextFile from '@mnd-frontend/icons/components/TextFile';
import IconThumbnail from '@mnd-frontend/icons/components/Thumbnail';

export const MaterialIcon = ({ type }: { type: MaterialType }) => {
  const mapping = {
    [MaterialType.BlogPost]: <IconStory $size="xxs" />,
    [MaterialType.Document]: <IconTextFile $size="xxs" />,
    [MaterialType.Event]: <IconCalendar $size="xxs" />,
    [MaterialType.Image]: <IconThumbnail $size="xxs" />,
    [MaterialType.News]: <IconStory $size="xxs" />,
    [MaterialType.Pressrelease]: <IconStory $size="xxs" />,
    [MaterialType.Video]: <IconLearningVideo $size="xxs" />,
  };

  return mapping[type];
};
